module.exports = window["MaterialUI"].Paper;